import React, { useState, useEffect } from "react";
import { Col, Card } from "react-bootstrap";
import { useNavigate } from "react-router";
import { activateMenu } from "redux/actions";
import { useAppDispatch } from "redux/store";
import { APIService } from "services";

type Props = {
    id: number;
    vibhag_name: string;
    gramas_formed: number;
    total_basti_count: number;
    total_gramas_count: number;
    total_gramas_formed: number;
    total_samithi_formed: number;
    samithi_formed: number;
    total_basti: number;
    total_gramas: number;
};
export const DashboardCard: React.FC<Props> = ({ id, total_basti_count, total_samithi_formed, total_gramas_count, total_gramas_formed, vibhag_name, gramas_formed, samithi_formed, total_basti, total_gramas }) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    // const handleCardClick = (path) => {
    //     dispatch(activateMenu(path))
    //     navigate(path, { replace: true });
    // }
    const [pranthaCount, setPranthaCount] = useState([])

    const handleCardClick = (id) => {
        //     // console.log("handleCardClickpath",path)
        //     APIService.api().post("https://lhac.lokahitam.net/api/v1/samithi_members/searchWithFields",{type:"vibhag",type_id:""}).then((resp) => {
        //     console.log("resp1122",resp)
        //     setpranthaCount (resp.data.SamithiReport)
        //    })
        // dispatch(activateMenu(path))
        localStorage.setItem('vibhag_name', vibhag_name)
        navigate('/jillareports/' + id, { replace: true });
    }

    return (
        <>
            <Col md={4} xl={3} xs={6} className="cursor-pointer mb-4" onClick={() => { handleCardClick(id); }}>

                <Card className=" shadow h-100 py-2" style={{ borderLeft: (gramas_formed > 0 || samithi_formed > 0) ? '5px solid #194380' : '5px solid #FF0000' }}>
                    <Card.Body style={{ padding: "2.2rem" }}>
                        <div className="row no-gutters align-items-center" >
                            <div className="col mr-2">
                                <div className="text-xl font-weight-bold  text-uppercase mb-1" style={{ color: (gramas_formed > 0 || samithi_formed > 0) ? '#194380' : '#FF0000' }}>
                                    <p>{vibhag_name}</p></div>
                                <div className=" mb-0 font-weight-bold text-gray-800"></div>
                            </div>
                            <div className=" mb-0.4 font-weight-bold text-gray-800">
                                {/* <i className="fas fa-clipboard-list fa-2x text-gray-300"></i> */}
                                <p>{samithi_formed}  Over  / {total_basti}  Total  Basthis</p>
                            </div>
                            <div className=" mb-0 font-weight-bold text-gray-800">
                                {/* <i className="fas fa-clipboard-list fa-2x text-gray-300"></i> */}
                                <p>{gramas_formed} Over  /  {total_gramas} Total Villages</p>
                            </div>
                        </div>
                    </Card.Body>

                </Card>
            </Col>
        </>
    );
};

